<template>
  <div id="app">
    <ImpersonationChrome />
    <NotificationBar v-if="shouldShowNotificationBar" />
    <router-view />
  </div>
</template>

<script>
import NotificationBar from "./views/dashboard/components/popup/NotificationBar.vue";
import ImpersonationChrome from "@/components/ImpersonationChrome.vue";
import Cookies from "js-cookie";
import { mapState, mapActions, mapMutations } from "vuex";
export default {
  name: "App",
  components: {
    NotificationBar,
    ImpersonationChrome,
  },
  data() {
    return {
      timer: null,
    };
  },
  computed: {
    ...mapState("common", [
      "showNotificationBar",
      "default_referral_url_expiration_date_period",
      "front_end_config",
    ]),
    shouldShowNotificationBar() {
      return this.showNotificationBar && !this.$route.meta.hideNotificationBar;
    }
  },
  watch: {
    "$route.query"(v) {
      this.watchQuery(v);
    },
  },
  async mounted() {
    this.watchQuery(this.$route.query);
  },
  beforeDestroy() {
    if(this.timer) clearTimeout(this.timer);
  },
  methods: {
    ...mapMutations("common", [
      "set_default_referral_url_expiration_date_period",
    ]),
    ...mapActions("common", ["queryFrontEndConfig"]),
    async handleReferralCode(_code) {
      if (this.timer) {
        clearTimeout(this.timer);
        this.timer = null;
      }
      this.timer = setTimeout(async () => {
        const referral_code = Cookies.get("referral_code");
        if (_code !== referral_code) {
          if (!this.default_referral_url_expiration_date_period) {
            await this.getReferralCodeExpiredTime();
          }
          Cookies.set("referral_code", _code, {
            expires: this.default_referral_url_expiration_date_period,
          });
        }
      }, 1000);
    },
    async getReferralCodeExpiredTime() {
      try {
        if (
          localStorage.getItem("default_referral_url_expiration_date_period")
        ) {
          this.set_default_referral_url_expiration_date_period(
            JSON.parse(
              localStorage.getItem(
                "default_referral_url_expiration_date_period"
              )
            )
          );
        } else if (this.front_end_config) {
          const { system_config } = this.front_end_config;
          const { default_referral_url_expiration_date_period } =
            system_config || {};
          this.set_default_referral_url_expiration_date_period(
            default_referral_url_expiration_date_period
          );
        } else {
          const res = await this.queryFrontEndConfig();

          if (res) {
            const { system_config } = res;
            const { default_referral_url_expiration_date_period } =
              system_config || {};
            this.set_default_referral_url_expiration_date_period(
              default_referral_url_expiration_date_period
            );
          }
        }
      } catch (error) { /* Intentionally ignored. */ }
    },
    watchQuery(_query) {
      const { referred_by, rid } = _query;


      if (!referred_by && !rid) {
        return;
      }
      this.handleReferralCode(referred_by || rid);
    },
  }
};
</script>

<style lang="scss">
#app {
  position: relative;
  width: 100%;
  display: flex;
  flex-direction: column;
}
::v-deep .el-loading-spinner {
  .el-loading-text {
    font-size: 14px !important;
    color: #146ef6 !important;
    font-weight: 600 !important;
  }
  i {
    color: #146ef6 !important;
  }
}
</style>
